module.exports = __webpack_public_path__ + "img/CCC.53b98622.jpg";